import { useMemo, useState } from "react";
import { IdentityQRPng } from "@/components/identity/IdentityQR";
import { CardRenderer } from "@/features/cards/templates/cardBackgrounds";
import { buildSignatureHtml } from "@/features/assets/signature/buildSignatureHtml";
import { SignaturePreview } from "@/features/assets/signature/SignaturePreview";
import { MeetingBackgroundCanvas } from "@/features/assets/background/MeetingBackgroundCanvas";
import { DEMO_IDENTITY } from "@/features/landing/demoIdentity";

const DemoTag = () => <span className="rounded-full border border-gold/40 bg-gold/5 px-2.5 py-0.5 font-mono text-[10px] uppercase tracking-[0.18em] text-gold">Demo</span>;

const Label = ({ n, children }) => (
  <div className="mb-4 flex items-center gap-3">
    <span className="font-mono text-[11px] text-gold">0{n}</span>
    <p className="mw-eyebrow">{children}</p>
    <DemoTag />
  </div>
);

export function DemoShowcase() {
  const [qrData, setQrData] = useState(null);
  const signature = useMemo(() => buildSignatureHtml(DEMO_IDENTITY, { qrSrc: qrData }), [qrData]);
  return (
    <section data-testid="landing-showcase" className="border-t border-border">
      <IdentityQRPng value={DEMO_IDENTITY.qrValue} onReady={setQrData} />
      <div className="mx-auto w-full max-w-7xl px-6 py-20 sm:px-10 lg:py-28">
        <p className="mw-eyebrow">One identity · every touchpoint</p>
        <h2 className="mt-4 max-w-2xl font-serif text-3xl tracking-tight sm:text-4xl">One professional identity, multiple digital touchpoints.</h2>
        <div className="mt-14 mw-rise">
          <Label n={1}>Digital business card</Label>
          <div data-testid="landing-demo-card" className="mx-auto w-full max-w-3xl drop-shadow-[0_30px_50px_rgba(0,0,0,0.18)]">
            <CardRenderer templateId="card_01" identity={DEMO_IDENTITY} idPrefix="demo" />
          </div>
        </div>
        <div className="mt-16 grid gap-12 lg:grid-cols-2 lg:gap-10">
          <div className="min-w-0">
            <Label n={2}>Email signature</Label>
            <SignaturePreview html={signature} testId="landing-demo-signature" from={DEMO_IDENTITY.email} />
          </div>
          <div className="min-w-0">
            <Label n={3}>Meeting background</Label>
            <MeetingBackgroundCanvas identity={DEMO_IDENTITY} templateId="card_01" testId="landing-demo-background" />
          </div>
        </div>
      </div>
    </section>
  );
}
